import React from 'react';
const AuthCtx = React.createContext(null);
export function AuthStoreProvider({ value, children, }) {
    return React.createElement(AuthCtx.Provider, { value: value }, children);
}
export function useAuth() {
    return React.useContext(AuthCtx);
}
